import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env';
import { getTrackingUUID } from 'src/dataLayer/localData/cookies';

export const ERROR_KEYS = {
    422: {
        key: 'change_password_page.error_message_timeout'
    },
    default: {
      key: 'change_password_page.error_message_generic'
    }
  };

const getPayload = ({
  password,
  confirmPassword,
  passwordResetToken,
  captchaResponseToken
}) => {
  const payload  = {
    account: {
      token: passwordResetToken,
      password,
      password_confirmation: confirmPassword,
      captcha: {
          token: captchaResponseToken
      }
    }
  };
  return payload;
};

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'X-Babbel-Tracking-UUID': getTrackingUUID()
  };
  return headers;
};

export default async (props) => {
  try {
    const response = await fetch(`${APIGATEWAY_BASE_URL}/v5/${props.locale}/passwords/update`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(getPayload(props))
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorKey = ERROR_KEYS[response.status]?.key || ERROR_KEYS.default.key;
      return {
        success: false,
        error: errorKey,
        status: response.status,
        data: errorData
      };
    }

    const data = await response.json();
    return {
      success: true,
      data
    };

  } catch (error) {
    return {
      success: false,
      error: ERROR_KEYS.default.key,
      networkError: true,
      message: error.message
    };
  }
};
